import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetPersonalAgentLink } from 'src/models/responseTypes/PersonalAgentLink';

const initialState: GetPersonalAgentLink = {
  personalLink: undefined,
  agentCode: undefined,
  brokerLicense: undefined,
};

const personalAgentLinkSlice = createSlice({
  name: 'personalAgentLink',
  initialState,
  reducers: {
    updatePersonalAgentLinkSlice: (
      state,
      action: PayloadAction<GetPersonalAgentLink | null | undefined>,
    ): void => {
      state.agentCode = action.payload?.agentCode;
      state.brokerLicense = action.payload?.brokerLicense;
      state.personalLink = action.payload?.personalLink;
    },
  },
});

export const { updatePersonalAgentLinkSlice } = personalAgentLinkSlice.actions;

export default personalAgentLinkSlice.reducer;
